import React, { useState } from 'react';

import ActionLink from '../../builder/ActionLink';
import TermsAndConditionsLayer from '../layers/TermsAndConditionsLayer';

const TermsButton = (props) => {
	const [ display_layer, setDisplayLayer ] = useState(false);

	const promotion = props?.promotion ?? false;
	if(promotion === false) return null;

	const is_builder = props?.is_builder ?? false;
	const use_react = true; //window?.use_react ?? false;	// once all the frontend is pure react, this can be deleted
	
	const label = props?.children ?? "Terms and conditions";

	const icon = props?.icon ?? 'knk-toc';
	const external_url = promotion?.external_toc_url ?? false;
	const target = '_blank';
	const has_link = (external_url !== false) ? true : false;

	return (
		<>
			<ActionLink
				icon={(icon !== false) ? icon : null}
				_href={(!is_builder && has_link) ? external_url : null}
				_target={target}
				_class={{ other:'toc_btn' }}
				onClick={(!is_builder && use_react && !has_link) ? () => setDisplayLayer(true) : null}
			>{label}</ActionLink>

			{(use_react && display_layer) && (
				<TermsAndConditionsLayer
					promotion={promotion}
					close={() => setDisplayLayer(false)}
					is_builder={is_builder}
				/>
			)}
		</>
	)
};

export default TermsButton;